module.exports = __webpack_public_path__ + "img/docx-file.a78519ce.svg";